import { useLingui } from '@lingui/react/macro';
import { useWeekdayFormatter } from '../utils/date-time-format';
import { ScheduleBlock } from './schedule-block';
import { useScheduleContext } from './schedule-context';
import { ScheduleItem } from './schedule-item';

export function RenderRegularDays() {
  const { regularDays, inSpecialInterval } = useScheduleContext();
  const formatWeekday = useWeekdayFormatter();
  const { t } = useLingui();

  return (
    <ScheduleBlock>
      {regularDays.map(({ date, hours, isClosed, isToday }) => (
        <ScheduleItem
          key={date.getTime()}
          hours={hours}
          highlight={isToday && !inSpecialInterval}
          isClosed={isClosed}
          title={(() => {
            return isToday && !inSpecialInterval
              ? t`Today`
              : formatWeekday(date);
          })()}
        />
      ))}
    </ScheduleBlock>
  );
}
